import type { HTMLAttributes, ReactNode } from 'react';

import { cx } from '../../lib/cx';
import { Icon, type IconName } from '../Icon';

import styles from './Chip.module.css';

export type ChipTone = 'success' | 'focus' | 'locked' | 'accent' | 'neutral' | 'danger' | 'warning';

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  /** success: mastered; focus: current; locked: not open yet; accent, neutral: labels. */
  tone?: ChipTone;
  icon?: IconName;
  children: ReactNode;
}

/**
 * A status or a label. The tone is never the only carrier of the meaning: the text
 * says it, and an icon may repeat it.
 */
export function Chip({ tone = 'neutral', icon, className, children, ...rest }: ChipProps) {
  return (
    <span className={cx(styles.chip, styles[tone], className)} data-tone={tone} {...rest}>
      {icon ? <Icon name={icon} size="var(--hs-chip-icon)" /> : null}
      {children}
    </span>
  );
}
